import { render, staticRenderFns } from "./CustomerActivityEmailModal.vue?vue&type=template&id=006fa149&"
import script from "./CustomerActivityEmailModal.vue?vue&type=script&lang=js&"
export * from "./CustomerActivityEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports